import { render } from "./portal-no-account.vue?vue&type=template&id=613ecac0"
import script from "./portal-no-account.vue?vue&type=script&lang=js"
export * from "./portal-no-account.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__